var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 5.72266V3.63541C6.5625 2.80469 7.24219 2.125 8.07291 2.125H15.9271C16.7579 2.125 17.4375 2.80469 17.4375 3.63541V5.72266",
    stroke: "#464646",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3594 12.4688V20.4727C22.3594 21.246 21.7264 21.8789 20.9531 21.8789H3.04688C2.27358 21.8789 1.64062 21.2461 1.64062 20.4727V12.5156",
    stroke: "#464646",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 14.8398C5.16614 14.5563 0.703125 13.1383 0.703125 10.5858V7.25781C0.703125 6.4833 1.33481 5.85156 2.10938 5.85156H21.8906C22.6651 5.85156 23.2969 6.48334 23.2969 7.25781V10.5858C23.2969 13.1543 18.7775 14.574 13.7812 14.845",
    stroke: "#464646",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2656 13.4453H13.7344V15.0625C13.7344 15.952 13.0066 16.6797 12.1172 16.6797H11.8828C10.9934 16.6797 10.2656 15.952 10.2656 15.0625V13.4453Z",
    stroke: "#464646",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.ffd02a428d1ae66f1b70f0a5579d4d4d.svg";
export { ForwardRef as ReactComponent };